/**
 * Client-side Europe hint for the consent gate.
 *
 * This host has no geo header we can read (apex is grey-cloud Lovable, and
 * this Worker has no CF-IPCountry binding). IANA timezone is the honest
 * signal we already have: an EU/EEA/UK/CH visitor's clock is almost always
 * on a Europe/* zone, plus the Atlantic/Asia/Arctic exceptions below.
 *
 * Keep the zone list in sync with the inline copy in index.html.
 */

const EUROPE_TZ = /^(Europe\/|Atlantic\/(Reykjavik|Canary|Madeira|Azores|Faroe)|Arctic\/Longyearbyen|Asia\/(Nicosia|Famagusta))/;

export function isEuropeVisitor(
  timeZone: string | undefined = readTimeZone(),
): boolean {
  return EUROPE_TZ.test(timeZone || '');
}

function readTimeZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || '';
  } catch {
    return '';
  }
}

export function hasStoredAnalyticsConsent(): boolean {
  if (typeof localStorage === 'undefined') return false;
  try {
    const raw = localStorage.getItem('cookie-consent');
    if (!raw) return false;
    const stored = JSON.parse(raw) as { analytics?: boolean };
    return stored.analytics === true;
  } catch {
    return false;
  }
}

/** False when Europe has not granted analytics — do not queue gtag/dataLayer hits. */
export function canSendClientAnalytics(): boolean {
  return !isEuropeVisitor() || hasStoredAnalyticsConsent();
}
